import { Typography } from "@circle-react-uikit/Typography";
import type { ReactNode } from "react";

import type { PlusBannerSource } from "@/react/hooks/analytics/types";

import { PlanSummaryContainer } from "../PlanSummaryContainer";
import { PlusPlanCtaButton } from "../PlusPlanCtaButton";
import { PlusPromotionImage } from "./PlusPromotionImage";

interface PlusPlanSummaryProps {
  ctaHref?: string;
  description: string;
  source: PlusBannerSource;
  title: ReactNode;
}

export const PlusPlanSummary = ({
  title,
  description,
  source,
  ctaHref,
}: PlusPlanSummaryProps) => (
  <PlanSummaryContainer>
    <div className="flex flex-col gap-2">
      {title}
      <Typography.BodySm color="text-default">{description}</Typography.BodySm>
    </div>

    <PlusPromotionImage />

    <PlusPlanCtaButton source={source} ctaHref={ctaHref} />
  </PlanSummaryContainer>
);
